import { Navigate, Route, Routes } from "react-router-dom";
import RequireAuth from "./components/RequireAuth";
import RequireStaff from "./components/RequireStaff";
import LoginPage from "./pages/LoginPage";
import ProjectsPage from "./pages/ProjectsPage";
import UsersPage from "./pages/UsersPage";
import ProjectWorkspacePage from "./pages/ProjectWorkspacePage";
import HierarchyPage from "./pages/HierarchyPage";
import SurveyTimingPage from "./pages/SurveyTimingPage";
import SessionsPage from "./pages/SessionsPage";
import ReopenRequestsPage from "./pages/ReopenRequestsPage";
import { Toaster } from "./components/ui/sonner";

// Route-level cross-fade (AnimatePresence mode="wait" + a PageFade wrapper
// starting at opacity: 0) used to sit here. Removed: mode="wait" holds the
// incoming page fully mounted but invisible until the outgoing one finishes
// exiting, which is a real, visible blank-page window on every navigation --
// caught directly by screenshotting mid-transition: a fully-populated table
// (correct DOM, correct color, opacity still 0) rendering as nothing. For a
// console staff click through dozens of times a day, that is a cost with no
// offsetting benefit, not a subtle polish detail. Navigation is instant now.

export default function App() {
  return (
    <>
      {/* Global toast provider — renders toasts triggered from anywhere via toast() */}
      <Toaster />

      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <ProjectsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/users"
          element={
            <RequireAuth>
              <RequireStaff>
                <UsersPage defaultTab="manage" />
              </RequireStaff>
            </RequireAuth>
          }
        />
        <Route
          path="/users/create"
          element={
            <RequireAuth>
              <RequireStaff>
                <UsersPage defaultTab="create" />
              </RequireStaff>
            </RequireAuth>
          }
        />
        <Route
          path="/reopen-requests"
          element={
            <RequireAuth>
              <RequireStaff>
                <ReopenRequestsPage />
              </RequireStaff>
            </RequireAuth>
          }
        />
        <Route
          path="/sessions"
          element={
            <RequireAuth>
              <RequireStaff>
                <SessionsPage />
              </RequireStaff>
            </RequireAuth>
          }
        />
        <Route
          path="/projects/:projectId"
          element={
            <RequireAuth>
              <ProjectWorkspacePage />
            </RequireAuth>
          }
        />
        <Route
          path="/projects/:projectId/hierarchy"
          element={
            <RequireAuth>
              <RequireStaff>
                <HierarchyPage />
              </RequireStaff>
            </RequireAuth>
          }
        />
        <Route
          path="/projects/:projectId/timing"
          element={
            <RequireAuth>
              <RequireStaff>
                <SurveyTimingPage />
              </RequireStaff>
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

